import styled from 'styled-components'
import { Colors } from '@pinchenterprisesnpm/friday-ui'

export const StyledText = styled.div`
  color: ${Colors.dark};

  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 140%;
  margin-top: 8px;
`
